import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'

type ProductAddonSortButtonProps = ProductAddonSortButtonLogicProps &  BaseButtonModalSortListProps & {
    extraWhereParams: TwinDictionary
    urlGetData: string
}

const ProductAddonSortButton: React.FC<ProductAddonSortButtonProps> = ({ urlGetData, url, ...rest }) => {
    const { updateOrder } = useProductAddonSortButtonLogic({url})
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom={urlGetData} {...rest} />
    )
}

interface ProductAddonSortButtonLogicProps {
    url: string
}

const useProductAddonSortButtonLogic = ({ url }: ProductAddonSortButtonLogicProps) => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const res = await twinFetchPostText(url, { productAddons: data })
        if (res) {
            return true
        }
        return false
    }, [url])

    return { updateOrder }
}

export default ProductAddonSortButton